import { take, fork, all } from 'redux-saga/effects';
import { apiTask } from '../app/sagas';
import { api } from '../app/api';
import * as actions from './controlPanelActions';

export const getLogs = apiTask(actions.GET_LOGS, api.post, '/evaluation-system/getLogs.php');
export function* watchGetLogs() {
  while (true) {
    const { payload } = yield take(actions.GET_LOGS);
    yield fork(getLogs, payload);
  }
}

export const getLogsRead = apiTask(
  actions.GET_LOGS_READ,
  api.post,
  '/evaluation-system/getLogsRead.php',
);
export function* watchGetLogsRead() {
  while (true) {
    const { payload } = yield take(actions.GET_LOGS_READ);
    yield fork(getLogsRead, payload);
  }
}

// Root module saga
export function* sagas() {
  yield all([fork(watchGetLogs), fork(watchGetLogsRead)]);
}
